import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import { useDebounce } from "use-lodash-debounce";
import Field from "./Field";
import CRUDButton from "./CRUDButton";
import get from "lodash/get";
import UnconfiguredComponent from "../../common3/UnconfiguredComponent";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.colors.on.warning};
  min-height: 160px;
  padding: 15px;
  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 4px,
    ${(p) => p.theme.colors.warning} 2px,
    ${(p) => p.theme.colors.warning} 6px
  );
`;

const FieldWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-left: -4px;
  margin-right: -4px;
`;

const Loader = (props) => {
  const { runEffect, effects = {}, effectsLoading, extra, id } = props;
  const { type, registerId } = props?.extra || {};

  useEffect(() => {
    runEffect({
      source: "Components/Loader/builder",
      effectId: id,
      context: { type, registerId },
    });
  }, [type, registerId]);

  console.log("id-id", effects);

  const register = get(effects, [id], {});

  const { name, structure = [] } = register || {};

  console.log("structure", structure);

  if (!type) {
    return <UnconfiguredComponent hint="Select type to load" />;
  }

  if (!registerId) {
    return <UnconfiguredComponent hint="Select register to load" />;
  }

  return (
    <Wrapper>
      <FieldWrapper>
        {structure &&
          structure.map((field, i) => {
            return (
              <>
                <Field id={id} key={i} field={field} />
                <Field id={id} key={i} field={field} readonly={true} />
              </>
            );
          })}
      </FieldWrapper>
      <FieldWrapper>
        <CRUDButton
          action="create"
          name="Create"
          color="success"
          id={id}
          registerId={registerId}
        />
        <CRUDButton
          action="update"
          name="Update"
          color="warning"
          id={id}
          registerId={registerId}
        />
        <CRUDButton
          action="remove"
          name="Remove"
          color="danger"
          id={id}
          registerId={registerId}
        />
      </FieldWrapper>
    </Wrapper>
  );
};

export default Loader;
